import * as RadioGroup from '@radix-ui/react-radio-group';
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from 'react';
type DialogProps = {
  info?: any;
  setInfo?: Dispatch<SetStateAction<any>>;
  setValidate?: Dispatch<SetStateAction<boolean>> | void;
  validate?: boolean | void;
};
function StatusDetailsNegociacao({
  info,
  setInfo,
  setValidate,
  validate = true
}: DialogProps) {
  const [radiobox, setRadioBox] = useState(info || null);
  return (
    <>
      <div className="tw-w-[100%]">
        <div>
          <span className="tw-font-bold">
            Em negociação <a className="tw-text-red-500">*</a>
          </span>
          {/* <p className="tw-text-red-500 tw-text-xs">
            Preenchimento obrigatório
          </p> */}
        </div>
        <RadioGroup.Root
          className="tw-flex tw-gap-6"
          defaultValue=""
          value={radiobox}
        >
          <div className="tw-flex tw-gap-2 tw-items-center">
            <RadioGroup.Item
              className={`tw-bg-white tw-w-4 tw-h-4 tw-border-[0.1rem] tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] ${
                validate === true
                  ? ' tw-border-[#001E64]'
                  : ' tw-border-[#AA2C23]'
              }`}
              value="cotacao"
              onClick={(e) => {
                setRadioBox('cotacao');
                setInfo('cotacao');
              }}
              id="r1"
            >
              <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
            </RadioGroup.Item>
            <label className="Label" htmlFor="r1">
              Cotação enviada
            </label>
          </div>
          <div className="tw-flex tw-gap-2 tw-items-center">
            <RadioGroup.Item
              className={`tw-bg-white tw-w-4 tw-h-4 tw-border-[0.1rem] tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] ${
                validate === true
                  ? ' tw-border-[#001E64]'
                  : ' tw-border-[#AA2C23]'
              }`}
              value="transmissao"
              onClick={(e) => {
                setRadioBox('transmissao');
                setInfo('transmissao');
              }}
              id="r1"
            >
              <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
            </RadioGroup.Item>
            <label className="Label" htmlFor="r1">
              Proposta transmitida
            </label>
          </div>
        </RadioGroup.Root>
        {validate === false && (
          <div className="tw-mt-4 tw-w-[100%] tw-text-[#AA2C23]">
            <div className="tw-w-[100%] tw-rounded-lg">
              Por favor, selecione um dos campos{' '}
              <span className="tw-font-bold"> cotação enviada </span>
              <br />
              ou <span className="tw-font-bold"> proposta transmitida </span>.
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default StatusDetailsNegociacao;
